export const rfidCardsResource = {
  name: 'RFID Cards',
  fields: {
    id: 'ID',
    cardNumber: 'Card Number',
    cardUid: 'Card UID',
    cardType: 'Card Type',
    user: 'User',
    userId: 'User',
    userName: 'User Name',
    userType: 'User Type',
    vendor: 'Merchant',
    vendorId: 'Merchant',
    vendorName: 'Merchant Name',
    allowedSites: 'Allowed Premises',
    assignedSites: 'Assigned Premises',
    status: 'Status',
    isActive: 'Active',
    issuedDate: 'Issued Date',
    expiryDate: 'Expiry Date',
    lastUsed: 'Last Used',
    lastUsedAt: 'Last Used',
    lastUsedSite: 'Last Used Premises',
    usageCount: 'Usage Count',
    totalKwh: 'Total kWh',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
  },
  types: {
    standard: 'Standard',
    admin: 'Admin',
    guest: 'Guest',
    fleet: 'Fleet',
  },
  sections: {
    cardInfo: 'Card Information',
    assignment: 'Assignment',
    siteAccess: 'Premises Access',
    settings: 'Settings',
    usageHistory: 'Usage History',
  },
  validation: {
    cardNumberFormat: 'Must contain only hexadecimal characters (0-9, A-F)',
  },
  siteCount: 'premises',
  list: {
    subtitle: 'Manage RFID cards and premises assignments',
    filters: {
      search: 'Search by card number, user, or merchant',
    },
  },
  create: {
    title: 'Create RFID Card',
    subtitle: 'Register a new RFID card',
    infoMessage: 'RFID cards allow employees to authenticate at charging stations. Each card must be assigned to a user and merchant.',
    cardNumberHelperText: 'The unique identifier printed on the RFID card (hexadecimal format)',
    cardTypeHelperText: 'Select the type of access this card provides',
    vendorHelperText: 'Select the merchant/company that manages this card',
    userHelperText: 'Select the employee who will use this card',
    selectVendorFirst: 'Please select a merchant first to see available sites',
    noSitesAvailable: 'No sites are assigned to the selected merchant',
    noUsersAvailable: 'No RFID users available for this merchant',
    siteSelectionHelp: 'Select which premises this card can access. If no premises are selected, the card will have access to all merchant premises.',
    searchSites: 'Search and select premises...',
    usageInfo: 'Card Usage',
    usageHelperText: 'Once created, this card can be used immediately at any assigned charging station. Usage history and statistics will be tracked automatically.',
  },
  edit: {
    title: 'Edit RFID Card',
    subtitle: 'Update RFID card information',
    infoMessage: 'Manage RFID card details and access permissions. Changes take effect immediately.',
    cardNumberHelperText: 'Card number cannot be changed after creation',
    cardTypeHelperText: 'Select the type of access this card provides',
    vendorHelperText: 'Merchant cannot be changed after creation',
    userHelperText: 'Select the employee who will use this card',
    noSitesAvailable: 'No sites are assigned to the selected merchant',
    siteSelectionHelp: 'Select which premises this card can access. If no premises are selected, the card will have access to all merchant premises.',
    searchSites: 'Search and select premises...',
    assignmentHelperText: 'Merchant and user assignments cannot be changed after creation. Create a new card if you need to reassign.',
    deactivateWarning: 'Deactivating this card will immediately prevent it from being used at charging stations.',
  },
  show: {
    title: 'RFID Card Details',
    subtitle: 'View RFID card details',
    tabs: {
      details: 'Details',
      chargingHistory: 'Charging History',
    },
    noChargingHistory: 'No charging sessions found for this card.',
    columns: {
      session: 'Session',
      startTime: 'Start Time',
      site: 'Site',
      charger: 'Charger',
      energy: 'Energy',
      cost: 'Cost',
    },
  },
  status: {
    active: 'Active',
    suspended: 'Suspended',
    expired: 'Expired',
    lost: 'Lost',
  },
  cardType: {
    mifare_classic: 'MIFARE Classic',
    mifare_desfire: 'MIFARE DESFire',
    ntag: 'NTAG',
    other: 'Other',
  },
  userType: {
    app: 'App User',
    rfid: 'RFID Only',
  },
  actions: {
    bulkImport: 'Bulk Import',
    bulkExport: 'Export Cards',
    suspend: 'Suspend Card',
    activate: 'Activate Card',
    assignSites: 'Assign Sites',
  },
};

export const rfidCards = {
  'rfid-cards': rfidCardsResource,
};